<template lang="pug">
extends ../filter/dynamic-filter-template.pug

block item
    template(#receipts.drawer_session_id="props")
        div
            span.block {{ props.value.display_name }}
            small.text-muted(v-if="props.value.owner_outlets")
                | {{ props.value.outlet_name }} <br/>
            small.text-muted
                | {{ props.value.staff_name }}

    template(#receipts.day_operation_id="props")
        div
            span.block {{ props.value.display_name }}
            small.text-muted(v-if="props.value.owner_outlets")
                | {{ props.value.outlet_name }} <br/>
            small.text-muted
                | {{ props.value.staff_name }}
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import dynamicFilterBase from '@js/components/filter/dynamic-filter-base';
import tillFilterMixin from '@js/components/till-filter/till-filter-mixin';

export default {
    extends: dynamicFilterBase,

    mixins: [tillFilterMixin],

    props: {
        till_columns: {
            type: Object | Array,
            default: () => null,
        },

        hide_till_closure: {
            type: Boolean | Number,
            default: false,
        },

        show_attendant_cashier: {
            type: Boolean | Number,
            default: false,
        },
    },

    computed: {
        ...mapState('tillFilter', ['filters', 'searchMeta']),
    },

    created() {
        if (_.isNull(this.till_columns)) {
            this.till_columns = {
                hide_till_closure: this.hide_till_closure,
                show_attendant_cashier: this.show_attendant_cashier,
            };
        } else {
            this.till_columns.hide_till_closure = this.hide_till_closure;
            this.till_columns.show_attendant_cashier = this.show_attendant_cashier;
        }

        this.getSearchMeta(this.till_columns);
    },

    methods: {
        ...mapActions('tillFilter', ['getSearchMeta']),

        ...mapMutations('tillFilter', ['setFilters']),
    },
};
</script>
